module.exports = __webpack_public_path__ + "media/images/team/michael-victor-tezon-7dad7ddb8cb36fa5958549bb90a0c123.png";